import React, { useState } from 'react';
import * as Yup from 'yup';
import { Form, FormElement, Field } from '@progress/kendo-react-form';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
// components
import Modal from 'shared/modals/Modal';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';
import { FormInput } from 'shared/forms';
import CancelButton from 'shared/buttons/CancelButton';
import SaveButton from 'shared/buttons/SaveButton';
import DeleteButton from 'shared/buttons/DeleteButton';
// fetch
import { postRentalCompany, deleteRentalCompany } from 'src/fetch/rentalCompanies';

const RentalCompanyModal = ({ initialValues, onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = () => {
    setIsSubmitting(true);

    deleteRentalCompany(initialValues.id)
      .then(() => {
        onClose(true);
        toastr('success', 'Rental Company Deleted Successfully.');
      })
      .catch((error) => {
        errorToastr({
          error,
          messagePrefix: 'Rental Company Delete Failed',
        });
        setIsSubmitting(false);
      });
  };

  const handleSubmit = (values) => {
    postRentalCompany(values)
      .then(() => {
        onClose(true);
        toastr('success', 'Rental Company Submitted Successfully.');
      })
      .catch((error) => {
        errorToastr({
          error,
          messagePrefix: 'Rental Company Submit Failed',
        });
        setIsSubmitting(false);
      });
  };

  return (
    <Modal
      isOpen
      title={`${initialValues && initialValues.id ? 'Edit' : 'Add'} Rental Company`}
      handleClose={() => onClose(false)}
      containerStyle='medium'
    >
      <div className='modal-body-content'>
        <section className={`additional-charges-form ${isSubmitting ? 'hide-overflow' : ''}`}>
          <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            render={() => {
              return (
                <FormElement id='rental-company-form'>
                  <Field id='name' name='name' label='Rental Company' component={FormInput} />

                  <DialogActionsBar>
                    <SaveButton type='submit' icon='save' />
                    {initialValues?.id && (
                      <DeleteButton type='button' className='error' icon='delete' onClick={handleDelete} />
                    )}
                    <CancelButton type='button' onClick={() => onClose(false)} />
                  </DialogActionsBar>
                </FormElement>
              );
            }}
          />
        </section>
      </div>
    </Modal>
  );
};

export default RentalCompanyModal;
